module.exports = __webpack_public_path__ + "media/images/launching_border-198bfd981eed619bc3405b63c9f99cde.jpg";